<template>
  <div class="drawcash-box" ref="container">
    <mu-load-more
      @refresh="refresh"
      :refreshing="refreshing"
      :loaded-all="loaded_all"
      :loading="loading"
      @load="load"
    >
      <div class="content">
        <div class="list-item" v-for="(item, index) in drawcashList" :key="`list-item_${index}`">
          <div class="before">
            <div class="type">提现</div>
            <div class="time">{{ item.createTime || '-' }}</div>
          </div>

          <div>
             <div class="money">
                {{ item.amount || '0.00' }}元
              </div>
              <div v-if="item.status == '完成'" class="status0">完成</div>
              <div v-if="item.status == '失败'" class="status1">提现失败</div>
              <div v-if="item.status == '提现中'" class="status2">提现中</div>
          </div>
         
        </div>
        <div class="more" v-if="drawcashList.length == 0">暂无更多</div>
      </div>
    </mu-load-more>
  </div>
</template>

<script>
import { getCashRecord } from "@/api/newApi";
import { Toast } from "vant";
import "vant/lib/toast/style/index";
import {digitUtil} from "@/utils/utils";
export default {
  data() {
    return {
      num: 10,
      nolist: true,
      loaded_all: false,
      refreshing: false,
      loading: false,
      drawcashList: [],
    };
  },
  mounted() {
    this.getList({ pageNo: 1, pageSize: this.num });
  },
  methods: {
    handleControlNumber: digitUtil,
    getList(params) {
      getCashRecord(params).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            this.drawcashList = res.data.records;
            this.nolist = false;
            if (res.data.pages == 1) {
              Toast("已加载全部数据");
              this.loaded_all = true;
            }
            if (res.data.pages == 0) {
              Toast("暂无提现记录");
            }
          }
        } else {
          this.drawcashList = [];
          Toast("暂无提现记录");
        }
      });
    },

    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      setTimeout(() => {
        this.refreshing = false;
        this.num = 1;
        this.drawcashList = [];
        this.getList({ pageNo: 1, pageSize: 5 });
      }, 1000);
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 3;
        this.getList({ pageNo: 1, pageSize: this.num });
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/state.scss";
.drawcash-box {
  padding: $divPadding;
  min-height: 100%;
  background-color: #F5F5F6;

  .content {
    background-color: white;
    border-radius: $borderRadius;
    padding: $divPadding;
    padding-bottom: 0.7rem;

    .list-item {

      display: flex;
      padding: $divPadding 0;
      border-bottom: 1px solid #ECECEC;


      &:first-child {
        padding-top: 0;
      }

      .before {
        flex: 1;

        .type {
          color: #3D3D3D;
          font-size: 0.3783rem;
        }

        .time {
          margin-top: 0.1rem;
          color: #888888;
          font-size: 0.3243rem;
        }
      }

      .money {
        align-self: center;
      }
    }

    .more {
      padding: 0.2rem;
      text-align: center;
      font-size: 0.3243rem;
      color: #cccccc;
    }
  }
}
</style>
